<!--suppress CheckEmptyScriptTag -->
<template>
  <svg class="svg-folder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M15.275,7.81785h12.47a1.74,1.74,0,0,1,1.74,1.74v18.1043H2.515V7.81785l.5405-2.162a1.74,1.74,0,0,1,1.68805-1.318h8.3029a1.74,1.74,0,0,1,1.68805,1.318Z"
      class="st0 stroke"/>
  </svg>
</template>

<script>
/**
 * SVG icon.
 */
export default {
  name: 'SvgFolder'
}
</script>

<style>
.st0 {
  fill: none;
  stroke: #796e65;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
